import toast from "./toast.js";
import { exposeFunctions } from "./core.js";

/**
 * Copy text to clipboard.
 * @param {string} text
 */
export function copyText(text) {
	return navigator.clipboard.writeText(text)
		.then(() => console.debug("Text copied!"))
		.catch((error) => {
			toast("Failed to copy");
			console.error(error);
		});

}

/**
 * Share text or url.
 * @param {string} title
 * @param {string} text
 * @param {string} url
 */
export function shareText(title, text, url) {
	if (navigator.share) {
		return navigator.share({ title, text, url })
			.then(() => console.debug("Text shared!"))
			.catch((error) => {
				// do not send a toast
				console.error(error);
			});
	}
	else {
		toast("Sharing is not supported. Text copied instead.");

		if (text && url)
			text += "\n" + url;
		else text = text || url;

		return copyText(text);
	}
}

exposeFunctions({ copyText, shareText });

